export default class UtilsPagination {
  static definePaginationQuery(paginationObject) {
    if (!paginationObject.page) {
      throw new Error('Pagination passed in wrong format or incomplete');
    }

    let pagination = `page=${paginationObject.page - 1}&size=${paginationObject.itemsPerPage}`;

    if (paginationObject.sortBy?.length > 0) {
      const { key, order } = paginationObject.sortBy[0];
      pagination = `${pagination}&sort=${key},${order}`;
    }

    return pagination;
  }

  static isSamePagination(pagination1, pagination2) {
    return (
      pagination1.itemsPerPage === pagination2.itemsPerPage &&
      pagination1.page === pagination2.page &&
      pagination1.sortBy === pagination2.sortBy
    );
  }

  static defaultPagination(itemsPerPage = 50, sortBy = []) {
    return {
      itemsPerPage,
      page: 1,
      sortBy,
    };
  }
}
